var Entry, about, accordion, animascroll, article, bForm, bSlider, bigLogo, brief, burger, callmodule, caseReview, checkbox, err404, feature, features, floatLabel, initTargets, inputfile, jform, layout, lazyImage, letters, likeShare, metrika, pageBanner, parallax, radiobox, ranger, service, slider, stepRange, tab, tableScroll, team, tipInWin, tooltip;

slider = require('../_modules/components/slider/slider');

callmodule = require('./functions/callmodule');

burger = require('../_modules/components/burger/burger');

features = require('../_modules/blocks/features/features');

feature = require('../_modules/components/feature/feature');

pageBanner = require('../_modules/blocks/page_banner/page_banner');

caseReview = require('../_modules/components/case_components/case_review/case_review');

accordion = require('../_modules/components/accordion/accordion');

tab = require('../_modules/components/tab/tab');

floatLabel = require('./functions/float-label');

jform = require('../_modules/components/jform/jform');

inputfile = require('../_modules/components/inputfile/inputfile');

animascroll = require('../_modules/components/animascroll/animascroll');

metrika = require('./functions/metrika');

initTargets = require('./functions/init-targets');

layout = require('../_modules/components/layout/layout');

likeShare = require('../_modules/blocks/like-share/like-share');

letters = require('../_modules/blocks/letters/letters');

bigLogo = require('../_modules/components/big-logo/big-logo');

radiobox = require('../_modules/components/radiobox/radiobox');

checkbox = require('../_modules/components/checkbox/checkbox');

brief = require('../_modules/blocks/brief/brief');

err404 = require('../_modules/blocks/404/404');

tableScroll = require('../_modules/components/case_components/case_table/case_table_scroll');

about = require('../_modules/blocks/about/about');

service = require('../_modules/blocks/service/service');

team = require('../_modules/blocks/team/team');

article = require("../_modules/blocks/article/article");

bSlider = require("../_modules/components/brief_components/b-slider/b-slider");

bForm = require("../_modules/components/brief_components/b-form/b-form");

tooltip = require('../_modules/components/tooltip/tooltip');

parallax = require('../_modules/components/parallax/parallax');

ranger = require('../_modules/components/brief_components/ranger/ranger');

stepRange = require("../_modules/components/brief_components/step-ranger/step-ranger");

tipInWin = require('../_modules/components/brief_components/tip-in-win/tip-in-win');

lazyImage = require("../_modules/components/lazy-image/lazy-image");

lazyImage();

Entry = require('../_modules/vue/entry');

document.addEventListener('DOMContentLoaded', function() {
  var vueInstance;
  vueInstance = new Entry();
  new slider();
  new team();
  new features();
  new feature();
  new callmodule();
  new burger();
  new pageBanner();
  new caseReview();
  new accordion();
  new tab();
  new floatLabel();
  new inputfile();
  new animascroll();
  new metrika();
  new initTargets();
  new layout();
  new likeShare();
  new letters();
  new bigLogo();
  new radiobox();
  new checkbox();
  new brief();
  new err404();
  new tableScroll();
  new about();
  new service();
  new article();
  new bSlider();
  new bForm();
  new jform();
  new tooltip('mouseenter');
  new ranger();
  new stepRange({
    actionType: 'init'
  });
  new tipInWin();
  return new parallax();
});
